import { Typography } from '@mui/material'
import { Link } from 'react-router-dom'
import {
  textOperators,
  equalityOperators,
  multiselectOperators,
  dateOperators
} from '../../../utils/constants/operators'
import { buildStatusColumn } from '../../fields/StatusField'

export const getInterventionColumns = ({ statusList = [], customers = [] }) => {
  const getCustomersFilter = () =>
    customers.map((customer) => ({
      name: customer.id,
      label: customer.customer_name
    }))

  return [
    {
      name: 'intervention_number',
      label: 'N° Intervention',
      isFilter: false,
      operators: textOperators
    },
    {
      name: 'customer_id',
      label: 'Client',
      isFilter: true,
      valueEditorType: 'multiselect',
      values: getCustomersFilter(),
      mapping: (id) => {
        const result = customers.find((item) => item.id === id)
        return result ? (
          <Typography state={{ id, history: '/interventions' }} component={Link} to={`/customers/view`}>
            {result.customer_name}
          </Typography>
        ) : (
          id
        )
      },
      operators: [...equalityOperators, ...multiselectOperators]
    },
    {
      name: 'intervention_date',
      label: 'Date Intervention',
      isFilter: true,
      inputType: 'date',
      type: 'date',
      format: 'DD/MM/YYYY',
      operators: dateOperators
    },
    buildStatusColumn('interventions', statusList),
    {
      name: 'summary',
      label: 'Titre',
      isFilter: false
    },
    {
      name: 'createdDateTime',
      label: 'Date Création',
      isFilter: true,
      inputType: 'datetime-local',
      type: 'date',
      format: 'DD/MM/YYYY HH:mm:ss',
      operators: dateOperators
    },
    {
      name: 'createdBy',
      label: 'Créé Par',
      isFilter: true,
      operators: textOperators
    },
    {
      name: 'lastModDateTime',
      label: 'Date Modification',
      isFilter: true,
      inputType: 'datetime-local',
      type: 'date',
      format: 'DD/MM/YYYY HH:mm:ss',
      operators: dateOperators
    },
    {
      name: 'lastModBy',
      label: 'Modifié Par',
      isFilter: true,
      operators: textOperators
    }
  ]
}

export const getInterventionFields = (user, location) => [
  [
    {
      name: 'customer_id',
      label: 'Client',
      required: true,
      type: 'select',
      defaultValue: () => location.state?.context?.customer_id ?? null,
      options: {
        type: 'api',
        object: 'customers',
        value: 'customer_name',
        returnField: 'id',
        returnFields: ['id'],
        filter: () => ({ company_id: user.company_id })
      },
      sizeDivided: 2,
      fullWidth: true,
      validation: [{ rule: 'req', error: 'Client obligatoire' }]
    }
  ],
  [
    {
      name: 'intervention_number',
      label: 'N° Intervention',
      readOnly: true,
      required: true,
      type: 'text',
      fullWidth: true,
      validationWhen: () => false,
      validation: [{ rule: 'req', error: 'N° Intervention obligatoire' }]
    },
    {
      name: 'intervention_date',
      label: 'Date',
      type: 'date',
      fullWidth: true,
      required: true,
      validation: [{ rule: 'req', error: 'Date obligatoire' }]
    }
  ],
  [
    {
      name: 'summary',
      label: 'Titre',
      type: 'text',
      fullWidth: true,
      required: true,
      sizeDivided: 2,
      validation: [{ rule: 'req', error: 'Titre obligatoire' }]
    }
  ],
  [
    {
      name: 'description',
      label: 'Description',
      type: 'text-multiline',
      fullWidth: true,
      required: true,
      sizeDivided: 2,
      validation: [{ rule: 'req', error: 'Description obligatoire' }]
    },
    {
      name: 'solution',
      label: 'Solution',
      type: 'text-multiline',
      fullWidth: true,
      required: true,
      sizeDivided: 2,
      isDisplay: (data) => data.status > 50,
      validation: [{ rule: 'req', error: 'Solution obligatoire' }]
    }
  ],
  [
    {
      name: 'material',
      label: 'Matériel',
      type: 'text-multiline',
      fullWidth: true,
      sizeDivided: 2
    }
  ]
]
